import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { StudentInfo } from "../student/studentSlice";
import { UserInfo } from "../user/userSlice";

export interface FaceQuerytate {
  state: LoadStateInfo;
  request?: RetrieveFaceQueryRequest;
  response?: FaceQueryResponse;
}

const initialState: FaceQuerytate = {
  state: notStarted(),
};

export interface FaceQueryResponse {
  students: StudentInfo[];
  users: UserInfo[];
}

export interface RetrieveFaceQueryRequest {
  schoolId: string;
  filter: string;
}

export const retrieveFaceQuery = createAsyncThunk(
  "retrieveFaceQuery",
  async (params: RetrieveFaceQueryRequest, thunkAPI) => {
    console.debug("retrieveFaceDetailsList");

    const response = await fetch(`${getBackendUrl()}/api/face/query/${params.schoolId}/${params.filter}`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      method: "GET",
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const faceQuerySlice = createSlice({
  name: "faceQuerySlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<RetrieveFaceQueryRequest>) => {
      if( state.request?.schoolId != action.payload.schoolId ) {
        state.state = notStarted();
        state.request = action.payload;
        state.response = undefined;
      }
    },
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
      state.response = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveFaceQuery.pending, (state, action) => {
        state.state =  loading();
        state.request = action.meta.arg;
        state.response = undefined;
      })
      .addCase(retrieveFaceQuery.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.response = action.payload;
      })
      .addCase(retrieveFaceQuery.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = faceQuerySlice.actions;

export const selectFaceQuery = (state: RootState) => state.faceQuery;

export default faceQuerySlice.reducer;
